
import React, { useState, ReactNode, cloneElement } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField,
    Card,
    CardContent,
    Divider,
    Avatar
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import {useTheme, alpha} from '@mui/material/styles';
import {SparkLineChart} from "@mui/x-charts/SparkLineChart";
import {LayoutFieldModel,
        IconType,
        IconJSON} from '../../models/models';
import {validateEmailField} from '../../utils/fieldValidations';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';
import {InfoCardFigure,
        KPICardText,
        KPICardIcon,
        KPICardRow} from '../../models/modelsDashboard';
import {CustomIconComponent} from '../icons/CustomIcon';




export const InfoCardFigureComponent: React.FC<{
  figure: InfoCardFigure
}> = ({
  figure
}) => {


  /******************************/

  const renderTitle = (title: KPICardText) => {
    const color = title.color ? title.color : "text.secondary";
    const weight = title.weight === 'bold' ? 700: 500;
    return (
      <Typography
        variant="body2"
        sx={{
          color: color,
          fontWeight: weight
        }}
      >
        {title.text}
      </Typography>
    )
  }

  /******************************/

  const renderSubTitle = (subtitle: KPICardText) => {
    const color = subtitle.color ? subtitle.color : "text.secondary";
    const weight = subtitle.weight === 'bold' ? 700: 500;
    return (
      <Typography
        variant="body2"
        sx={{
          color: color,
          fontWeight: weight
        }}
      >
        {subtitle.text}
      </Typography>
    )
  }

  /******************************/

  const renderRowElement = (element: KPICardText) => {

    const color = element.color ? element.color : "text.secondary";
    const weight = element.weight === 'bold' ? 700: 500;
    const fontSize = element.size ? element.size : 14;

    return (
      <Typography
        sx={{
          marginTop: 2,
          color: color,
          fontWeight: weight,
          fontSize: fontSize
        }}
      >
        {element.text}
      </Typography>
    )
  }

  ///

  const renderRow = (row: KPICardRow) => {
    const color = "text.secondary";
    const  weight= 500;
    const fontSize =  undefined;

    const justifyContent = row.justify ? row.justify : "space-between";

    return (
      <Box
        sx={{
          display: "flex",
          width: '100%',
          flexDirection: "row",
          justifyContent: justifyContent,
          alignItems: "top",
          gap: 4
        }}
      >
        {row.elements &&
         row.elements.map((thisElement: KPICardText) => renderRowElement(thisElement))}
      </Box>

    )
  }

  const renderRows = (rows: KPICardRow[]) => {
    return (
      rows.map((thisRow: KPICardRow) => renderRow(thisRow))
    )
  }

  /******************************/

  const renderIcon = (icon: KPICardIcon) => {
    const color = icon.color ? icon.color: 'text.secondary'
    const backgroundColor = icon.background_color ? icon.background_color : 'inherit'
    const type = icon.type ? icon.type as IconType : 'MuiIcon' as IconType
    const name = icon.name ? icon.name : '';

    const thisIcon: IconJSON = {Type_sys: type,
                                Name_sys: name,
                                Colour_sys: color,
                                BackgroundColour_sys: backgroundColor
                              }

    return (
      <Avatar
        sx={{
          color: color,
          backgroundColor: alpha(color,0.12),
          width: 36,
          height: 36
        }}
      >
        <CustomIconComponent
          icon={thisIcon}
          sx={{fontSize: 24}}
        />
      </Avatar>
    )
  }

  /******************************/

  return (
    <Card
      elevation={2}
      sx={{borderRadius: 4,
           backgroundColor: 'white',
           border: '1px solid',
           borderColor: 'divider',
           boxShadow: 'none',
           transition: 'all 0.2s ease',
           '&:hover': {
             boxShadow: 3,
             transform: 'translateY(-2px)'
           },
           height: '100%'}}
    >
      <CardContent>
        <Box
          sx={{
            display: "flex",
            width: '100%',
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "top",
            gap: 4
          }}
        >
          {figure.data.icon &&
            renderIcon(figure.data.icon)}

          <Box sx={{marginLeft: 0}}>
            {figure.data.title &&
              renderTitle(figure.data.title)}

            {figure.data.subtitle &&
              renderSubTitle(figure.data.subtitle)}
          </Box>
        </Box>

        <Divider sx={{mt: 2, mb: 2}}/>

        <Box
          sx={{
            display: "flex",
            width: '100%',
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "top",
            gap: 0
          }}
        >
           {figure.data.rows &&
             renderRows(figure.data.rows)}
        </Box>




      </CardContent>



    </Card>
  )
}
